global.$ = global.jQuery = require('jquery');

// import ModuleName from 'module-path';
// let libName = require('library-name');

document.addEventListener("DOMContentLoaded", function(event) {

    // wait until window, stylesheets, images, links, and other media assets are loaded
    window.onload = function() {

        // Toggle Menu - Toggle Menu Function
        jQuery('#toggle').click(function() {
            jQuery(this).toggleClass('active');
            jQuery('#navbarNavDropdown').toggleClass('open');
            jQuery('.mobile-logo').toggleClass('mobile-logo-light');
            jQuery('.site-header').toggleClass('header-open-fixed');
        });
        
        // Hamburger Menu - Remove the Hamburger menu Overlay after click
        jQuery('#main-menu li a').click(function() {
            jQuery('#navbarNavDropdown').removeClass('open');
            jQuery('.mobile-logo').removeClass('mobile-logo-light');
            jQuery('#toggle').removeClass('active');
            jQuery('.site-header').removeClass('header-open-fixed');
        });
        
        // Header - Add Sticky Header Function.
        jQuery(document).on('scroll', function() {
            if (jQuery(document).scrollTop() > 150) {
                jQuery('.site-header').addClass('sticky-header');
            } else {
                jQuery('.site-header').removeClass('sticky-header');
            }
        });

        // Scroll to Section - Add Scroll to Section Function.
        jQuery(document).ready(function(){
            document.querySelectorAll('.scroll-to-section a[href^="#"]').forEach(anchor => {
            anchor.addEventListener('click', function (e) {
                e.preventDefault();
        
                document.querySelector(this.getAttribute('href')).scrollIntoView({
                    behavior: 'smooth'
                });
            });
            });
        });

        // Home page services Items Animation
        jQuery(document).ready(function(){
            jQuery('.service-item').hover(function() {
                jQuery( this ).addClass( "active-service-item" );
                jQuery('.service-item').not(this).removeClass("active-service-item");
            });
        });

        // Mobile submenu toggle
        jQuery("#main-menu li.menu-item-has-children").append("<span class='dot-triggle hidden'><i class='fas fa-caret-down'></i></span>");
        jQuery(".dot-triggle").on("click", function(e) {
            e.preventDefault();
            var currentBox = jQuery(this).siblings("#main-menu .sub-menu").toggleClass("menu-active-mobile");
            jQuery("#main-menu .sub-menu.active-team").not(currentBox).removeClass("menu-active-mobile");
            
            var addclassnew = jQuery(this).closest(".dot-triggle").toggleClass("dot-active-mobile");
            jQuery(".dot-triggle.active-team").not(addclassnew).removeClass("dot-active-mobile");
        });

        // Home Making an Impact Section Function.
        jQuery('.slider-for-home').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            arrows: true,
            vertical: false,
            centerMode: false,
            adaptiveHeight: true,
            fade: false,
            //asNavFor: '.slider-nav-home'
        });

        // Partners Page Timeline Section Function.
        jQuery('.slider-for').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false,
            arrows: false,
            vertical: true,
            centerMode: false,
            fade: false,
            asNavFor: '.slider-nav',
            // responsive: [
            //     {
            //       breakpoint: 769,
            //       settings: {
            //         adaptiveHeight: false,
            //       },
            //     },
            //     {
            //       breakpoint: 768,
            //       settings: {
            //         adaptiveHeight: true,
            //       },
            //     },
            //     {
            //       breakpoint: 320,
            //       settings: {
            //         adaptiveHeight: true,
            //       },
            //     },
            //   ],
        });
        jQuery('.slider-nav').slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            //adaptiveHeight: true,
            centerPadding: '40px',
            asNavFor: '.slider-for',
            infinite: true,
            dots: false,
            arrows: false,
            vertical: true,
            centerMode: true,
            focusOnSelect: true
        });

        // Audio Play List
        jQuery(document).ready(function() {
            jQuery('audio').audioPlayer();
        });

        // Timeline Swiper Slider
        var swiper = new Swiper(".timelineSwiper", {
            slidesPerView: 1,
            grabCursor: true,
            autoHeight: false,
            navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            },
        });

        // News Header Over Swiper Slider
        var swiper = new Swiper(".newsHeadSwiper", {
            slidesPerView: 1,
            spaceBetween: 0,
            autoHeight: true,
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
            breakpoints: {
                320: {
                    pagination: false,
                },
                640: {
                    pagination: true,
                },
            },
        });

        // Podcast Swiper Slider
        var swiper = new Swiper(".podcastSwiper", {
            slidesPerView: 3,
            spaceBetween: 30,
            autoHeight: false,
            breakpoints: {
                320: {
                  slidesPerView: 1,
                  spaceBetween: 20,
                  autoHeight: true,
                },
                768: {
                  slidesPerView: 2,
                  spaceBetween: 30,
                  autoHeight: false,
                },
                1100: {
                  slidesPerView: 3,
                  spaceBetween: 40,
                  autoHeight: false,
                },
            },
        });

        // Mixed Income Home Swiper Slider
        var swiper = new Swiper(".mixedIncomeSwiper", {
            slidesPerView: 2,
            spaceBetween: 30,
            autoHeight: false,
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
            breakpoints: {
                320: {
                  slidesPerView: 1,
                  spaceBetween: 20,
                  autoHeight: true,
                },
                768: {
                  slidesPerView: 2,
                  spaceBetween: 30,
                  autoHeight: false,
                },
                1100: {
                    slidesPerView: 2,
                    spaceBetween: 40,
                    autoHeight: false,
                },
            },
        });

        // Education Pathways Swiper Slider
        var swiper = new Swiper(".educationPathwaysSwiper", {
            slidesPerView: 3,
            spaceBetween: 30,
            autoHeight: false,
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            breakpoints: {
                320: {
                    slidesPerView: 1,
                    spaceBetween: 20,
                    autoHeight: true,
                },
                768: {
                    slidesPerView: 2,
                    spaceBetween: 30,
                    autoHeight: false,
                },
                1100: {
                    slidesPerView: 3,
                    spaceBetween: 40,
                    autoHeight: false,
                },
            },
        });
        // Custome Arrow
        jQuery('.swiper-button-next').click(
            function(e){
            jQuery(this).parents('.educationPathwaysSwiperWrapper').find('.xnext').trigger('click');
       });
       jQuery('.swiper-button-prev').click(function(e){$(this).parents('.educationPathwaysSwiperWrapper').find('.xprev').trigger('click');});

        // Equal Heights Function
        $.fn.equalHeights = function(){
            var max_height = 0;
            jQuery(this).each(function(){
                max_height = Math.max(jQuery(this).height(), max_height);
            });
            jQuery(this).each(function(){
                jQuery(this).height(max_height);
            });
        };

        jQuery(document).ready(function(){
            jQuery('.equalHeights').equalHeights();
        });
    }

    // Header - Donate Toggale Function.
    jQuery(".donate-btn1").hover(function () {
        jQuery('.nav-donate-form1').addClass('open-donate-form');
        jQuery('.donate-btn1').addClass('donate-btn1-click');
    });

    // Header - Donate Toggale closs Function.
    jQuery(".close-donate-form1").click(function () {
        jQuery('.nav-donate-form1').removeClass('open-donate-form');
        jQuery('.donate-btn1').removeClass('donate-btn1-click');
    });

    // Header - Donate Toggale - get Selected ammount and Set in link Function
    jQuery(".amount1").click(function () {
        var isclass = jQuery(this).hasClass("donation-ammount-active");

        jQuery(".donation-ammount").removeClass("donation-ammount-active");
        jQuery("#other-div1").hide();
        
        if(isclass == false){
            var amount = this.id;
            jQuery("#"+amount).addClass("donation-ammount-active");
            document.getElementById("link1").setAttribute("href", `/donate/?amount=${amount}#donate_form` );
        }else{
            document.getElementById("link1").removeAttribute("href");
        }
        
    });

    // Header - Donate Toggale - get Selected ammount is other option Function
    jQuery("#other1").click(function () {
        var isclass = jQuery(this).hasClass("donation-ammount-active");
        jQuery(".donation-ammount").removeClass("donation-ammount-active");
        if(isclass == false){
            jQuery("#other1").addClass("donation-ammount-active");
            jQuery("#other-div1").show();
        }else{
            jQuery("#other-div1").hide();
        }
        document.getElementById("link1").removeAttribute("href"); 
    });
    
    jQuery('.other-amount1').on('blur', function() {
        document.getElementById("link1").setAttribute("href", "/donate/?amount=" + this.value);
        
    });

    let salAnimate = sal({
        threshold: 0.2,
        once: false,
    });  
    salAnimate.enable();

    const isMobile = window.matchMedia("only screen and (max-width: 760px)").matches;
        if (isMobile) {
    
       // console.log('mobile',mobile);
            document.getElementById('hero-header').style.backgroundImage="url("+mobile+")";
        }
        else
        {
           // console.log('desktop',desktop);
            document.getElementById('hero-header').style.backgroundImage="url("+desktop+")";
        }
});